<template>
  <base-hm-input :id="id"
                 :class="[
                   $attrs['class'],
                   { 'has-inline-icon-left': hasSlot('icon-inline-left') },
                   { 'has-inline-icon-right': hasSlot('icon-inline-right') },
                 ]"
                 :label="label"
                 :has-warning="hasWarning"
                 :help="help"
                 :has-focus="hasFocus"
                 :is-empty="isValueEmpty"
                 :name="name"
                 :cols="cols"
                 :hidden="hidden"
                 :style="iconCountStyleVariables"
                 :disabled="disabledCombined">
    <input v-if="lazy || disabledCombined"
           ref="input"
           :id="`${id}-input`"
           v-model.trim.lazy="internalValue"
           :data-vv-as="label"
           :data-vv-name="name"
           :name="name"
           :disabled="disabledCombined"
           :title="title"
           :autocomplete="autocomplete"
           :maxlength="maxlength"
           :type="type"
           :readonly="readonly"
           :class="['hm-input__input', { 'privacy--blur': privacyBlur}]"
           @change="onChange($event)"
           @paste="onPaste"
           @focus="onFocus"
           @blur="onBlur">
    <input v-else
           ref="input"
           :id="`${id}-input`"
           v-model.trim="internalValue"
           :data-vv-as="label"
           :data-vv-name="name"
           :name="name"
           :disabled="disabledCombined"
           :title="title"
           :autocomplete="autocomplete"
           :maxlength="maxlength"
           :type="type"
           :readonly="readonly"
           :class="['hm-input__input', { 'privacy--blur': privacyBlur}]"
           @change="onChange($event)"
           @paste="onPaste"
           @focus="onFocus"
           @blur="onBlur">
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper hm-input__icon__wrapper--left">
      <slot :hover="hover" :focus="hasFocus" name="icon-inline-left"></slot>
    </div>
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper hm-input__icon__wrapper--right">
      <slot :hover="hover" :focus="hasFocus" name="icon-inline-right"></slot>
    </div>
  </base-hm-input>
</template>

<script>

import { isNil, isFunction, trim, isArray } from 'lodash';
import HmInputMixin from '@/mixins/HmInputMixin';

export default {
  name: 'HmInput',

  mixins: [HmInputMixin],

  props: {
    value: {
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    hasWarning: {
      type: Boolean,
      required: false,
      default: false,
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'off',
    },
    maxlength: {
      type: Number,
      required: false,
      default: 255,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    hasValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconsRight: {
      type: Number,
      required: false,
      default: -1,
    },
    iconsLeft: {
      type: Number,
      required: false,
      default: -1,
    },
  },

  data: function () {
    return {
      hover: false,
      files: null,
    };
  },

  computed: {
    isValueEmpty: function () {
      return (this.type === 'file' && this.hasValue === false) || (this.type !== 'file' && (isNil(this.value) || trim(this.value).length === 0));
    },
    iconCountLeft: function () {
      if (this.iconsLeft >= 0) return this.iconsLeft;

      let slot = this.getSlot('icon-inline-left');
      slot = isNil(slot) || !isFunction(slot) ? slot : slot();

      if (isNil(slot)) return 0;
      else if (isArray(slot)) return slot.filter(it => typeof it.tag !== 'undefined').length;
      else return 1;
    },
    iconCountRight: function () {
      if (this.iconsRight >= 0) return this.iconsRight;

      let slot = this.getSlot('icon-inline-right');
      slot = isNil(slot) || !isFunction(slot) ? slot : slot();

      if (isNil(slot)) return 0;
      else if (isArray(slot)) return slot.filter(it => typeof it.tag !== 'undefined').length;
      else return 1;
    },
    iconCountStyleVariables: function () {
      return {
        '--icons-left': this.iconCountLeft,
        '--icons-right': this.iconCountRight,
      };
    },
  },

  methods: {
    blur() {
      if (this.hasFocus && !isNil(this.$refs) && !isNil(this.$refs.input)) {
        this.$refs.input.blur();
      }
    },
    onChange($event) {
      if (this.type === 'file') {
        this.files = isNil(this.$refs.input) ? null : this.$refs.input.files;
      }
      this.$emit('change', $event);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/components/lib/HmInput';

  input[type='file'] {
    height: 3.2rem;
    padding: 0.5rem 1rem 0.5rem;
  }

  .component__hm-input.text-right input {
    text-align: right;
  }
</style>

<style lang="scss">
  @import '~styles/import';

  .inline-button {
    @include icon-color($middlegray);
    @include icon-hover($text);
    &:hover {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInput.vue